export const getAlternativeVariantsColors = (consumablesMatrix, productDisplayedInTeaser) => {
    const { flavorDetails: teaserFlavorDetails, packagingFormatId: teaserPackagingFormatId, purchaseType: teaserPurchaseType, sku: teaserSku, } = productDisplayedInTeaser;
    // skip any logic if product displayed in teaser has no flavor (color) data
    if (!teaserFlavorDetails)
        return [];
    const { swatch_data: teaserSwatchData } = teaserFlavorDetails;
    return consumablesMatrix.items.reduce((colorVariants, currentValue) => {
        const { flavorDetails, packagingFormatId, purchaseType, sku } = currentValue;
        if (!flavorDetails)
            return colorVariants;
        if (packagingFormatId !== teaserPackagingFormatId || purchaseType !== teaserPurchaseType)
            return colorVariants;
        const { swatch_data, flavour_label } = flavorDetails;
        // currently displayed product color should not be in alternative colors
        if (teaserSwatchData === swatch_data || teaserSku === sku)
            return colorVariants;
        colorVariants.push({ value: swatch_data, label: flavour_label });
        return colorVariants;
    }, []);
};
//# sourceMappingURL=getAlternativeVariantsColors.js.map